import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/vee-validate";
import {extend} from "vee-validate";

import Toast, {POSITION} from "vue-toastification";
import "vue-toastification/dist/index.css";
import ConfirmModal from "./components/ui/confirm/index.js";
import LoaderModal from "./components/ui/loader/index.js";
import commonMixin from "./mixins/common.mixin";
import {VueMaskDirective} from "v-mask";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import VueApexCharts from "vue-apexcharts";
import VCalendar from "v-calendar";
import VueSignaturePad from "vue-signature-pad";

extend("email", {
  validate(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  },
  message: "Please enter a valid email address",
});

Vue.use(VueSignaturePad);
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: "AIzaSyCquNeDdlxVYTQJ6DKtZuzw4lVBPQJ4DEI",
  installComponents: true,
  vueGoogleMapsCompatibility: false,
});
Vue.use(VCalendar, {
  componentPrefix: "vc",
});
Vue.directive("mask", VueMaskDirective);
Vue.use(Toast, {
    timeout: 2000,
    position: POSITION.TOP_CENTER,
    pauseOnHover: false,
    hideProgressBar: true,
    maxToasts: 1,
    closeButton: false,
    // Auto-close is driven by a CSS animation; these two defaults pause it
    // on window blur / mousedown and can leave a toast stuck on screen.
    pauseOnFocusLoss: false,
    draggable: false,
    // Never queue toasts. A repeat of the visible message is ignored; a
    // different message replaces the visible one instead of waiting behind it.
    filterBeforeCreate(toast, toasts) {
        if (!toasts.length) return toast;
        const isDuplicate = toasts.some(
            (t) => t.content === toast.content && t.type === toast.type
        );
        if (isDuplicate) return false;
        Vue.$toast.clear();
        return toast;
    },
    transition: "toast-fade",
    transitionDuration: 250
});
Vue.use(ConfirmModal);
Vue.use(LoaderModal);
Vue.mixin(commonMixin);

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
